/*
 * @Author: wangshengqiang
 * @Date: 2021-04-23 16:08:14
 * @LastEditTime: 2021-04-23 16:20:15
 * @LastEditors: wangshengqiang
 * @Description:
 */
class EvenetHandle {
  constructor() {
    this.handleTypes = {};

    this.addType = (type, fn) => {
      if (this.handleTypes[type]) {
        throw new Error('');
      }

      this.handleTypes[type] = fn;
    };

    this.getHandleByType = type => {
      return this.handleTypes[type];
    };
  }

}

export default new EvenetHandle();